import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import { NavHeaderContext } from "../context/NavHeaderContext";

const useCustomSearchSetter = ({
  customSearch,
}: {
  customSearch: {
    icon: string;
    onClick: () => void;
  };
}) => {
  const { setHeaderNavMeta } = useContext(NavHeaderContext);
  const { locale } = useRouter();
  useEffect(() => {
    setHeaderNavMeta((prev) => ({ ...prev, customSearch }));
    setTimeout(() => {
      setHeaderNavMeta((prev) => ({ ...prev, customSearch }));
    }, 500);
    return () => {
      setHeaderNavMeta((prev) => ({ ...prev, customSearch: null }));
    };
  }, [locale]);
};

export default useCustomSearchSetter;
